import { observable } from 'mobx';

class ConfigStore {
  @observable help = {
    supportEmail: null,
    supportPhone: null,
    showHelpPage: false,
    helpContent: null
  };

  @observable data = {
    analyticsScript: null,
    description: null,
    hasReportEmailSendFeature: false,
    knowMoreUrl: null,
    name: null,
    published: true,
    reportEmailSendFeatureEnabled: false,
    signupAllowed: false,
    subdomain: null,
    domain: null
  };

  @observable custom = {
    autoSortModules: null,
    images: null,
    lookAndFeel: null,
    secondaryColor: null,
    selectedTemplate: null,
    defaultTemplate: null
  };

  @observable certificate = {
    allowProgressDisplay: null,
    canvas: null,
    certificates: [],
    hasSeason: null,
    hasChangeOnTemplate: false
  };

  @observable deleteButtonCertificate = {
    display: 'none',
    top: 0,
    left: 0
  };
}

export default new ConfigStore();
